import React from 'react';
// material-ui
import {
  useMediaQuery,
  Container,
  Link,
  Typography,
  Stack
} from "@mui/material";

// ==============================|| FOOTER - AUTHENTICATION ||============================== //

const AuthFooter = () => {
  const matchDownSM = useMediaQuery((theme) => theme.breakpoints.down("sm"));

  return (
    <Container maxWidth="xl">
      <Stack
        direction={matchDownSM ? "column" : "row"}
        justifyContent={matchDownSM ? "center" : "space-between"}
        spacing={2}
        textAlign={matchDownSM ? "center" : "inherit"}
      >
        <Typography variant="subtitle2" color="secondary" component="span">
          &copy; Aidemi Media Publishing&nbsp;2022
          <Typography
            component={Link}
            variant="subtitle2"
            href="https://aidemi.com"
            target="_blank"
            underline="hover"
          ></Typography>
        </Typography>

        <Stack
          direction={matchDownSM ? "column" : "row"}
          spacing={matchDownSM ? 1 : 3}
          textAlign={matchDownSM ? "center" : "inherit"}
        >
          {/* <Typography
            variant="subtitle2"
            color="secondary"
            component={Link}
            href="https://www.aidemi.com"
            target="_blank"
            underline="hover"
          >
            Aidemi Media Publishing
          </Typography> */}
          <Typography
            variant="subtitle2"
            color="secondary"
            component={Link}
            href="https://www.aidemi.com/privacy"
            target="_blank"
            underline="hover"
          >
            Privacy Policy
          </Typography>
          <Typography
            variant="subtitle2"
            color="secondary"
            component={Link}
            href="https://www.aidemi.com/contact"
            target="_blank"
            underline="hover"
          >
            Support
          </Typography>
        </Stack>
      </Stack>
    </Container>
  );
};

export default AuthFooter;
